import { createReactBindings } from '@slicesjs/react-core';

import type {
  RegistrationScheduleSharedMapContext,
  RegistrationScheduleSharedState,
} from './types';

export const {
  SlicesProvider,
  useReactiveMap,
  useReadSharedState,
  useSharedState,
  useWriteSharedState,
} = createReactBindings<
  RegistrationScheduleSharedState,
  RegistrationScheduleSharedMapContext
>();
